import { PickleballMatchFormatFormComponent } from './../pickleball-match-format-form/pickleball-match-format-form.component';
import { BadmintonMatchFormatFormComponent } from './../badminton-match-format-form/badminton-match-format-form.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { PlayerItemModule } from '../../_shared/components/player-item/player-item.module';
import { SelectTeamPlayerModule } from '../../_shared/components/select-team-player/select-team-player.module';
import { CountriesPageModule } from '../../countries/countries.module';
import { EmptyPageModule } from '../../empty-page/empty-page.module';
import { AddPlayerModule } from '../../_shared/components/add-player/add-player.module';
import { MatchFormatFormModule } from '../match-format-form/match-format-form.module';
import { CreateMatchComponent } from './create-match.component';
import { CreateMatchButtonComponent } from './create-match-button/create-match-button.component';
import { MatchScheduleComponent } from './match-schedule/match-schedule.component';
import { RoundNameComponent } from './round-name/round-name.component';
import { SharedModule } from '../../_shared/shared.module';
import { SelectParticipantComponent } from '../../participant-list/select-participant/select-participant.component';
import { TableTennisMatchFormatFormComponent } from '../table-tennis-match-format-form/table-tennis-match-format-form.component';
import { SquashMatchFormatFormComponent } from '../squash-match-format-form/squash-match-format-form.component';

@NgModule({
    imports: [
        ReactiveFormsModule,
        FormsModule,
        IonicModule,
        CommonModule,
        CountriesPageModule,
        TranslateModule.forChild(),
        AddPlayerModule,
        SelectTeamPlayerModule,
        EmptyPageModule,
        MatchFormatFormModule,
        PlayerItemModule,
        SharedModule,
        PickleballMatchFormatFormComponent,
        BadmintonMatchFormatFormComponent,
        SelectParticipantComponent,
        TableTennisMatchFormatFormComponent,
        SquashMatchFormatFormComponent
    ],
    declarations: [
        CreateMatchComponent,
        CreateMatchButtonComponent,
        MatchScheduleComponent,
        RoundNameComponent,
    ],
    exports: [
        CreateMatchButtonComponent
    ]
})

export class CreateMatchModule { }
